export default {
  register: "注册",
  welcome: "欢迎",
  textWelcome: "欢迎光临",
  textGoodMorning: "早上好",
  textGoodAfternoon: "下午好",
  textGoodEvening: "晚上好",
  textGoodNight: "晚安",
  loginFail: "登录失败",
  phone: "手机号码",
  email: "电子邮箱",
  agreeTermAndCondition: "同意条款与条件",
  pleaseAgreeTermAndCondition: "请接受隐私政策",
  back: "返回",
  termAndCondition: "条款与条件",
  termAndCondition2: "服务条款",
  cancel: "取消",
  confirm: "确认",
  confirmDefault: "确定",
  confirmRegistration: "确认注册",
  addItem: "添加项目",
  required: "请填写此字段",
  zipcode: "邮政编码",
  sub_district: "街道/镇",
  district: "区/县",
  province: "省份",
  save: "保存",
  saveDraft: "保存草稿",
  close: "关闭",
  name: "名",
  surname: "姓",
  birthDay: "出生日期",
  gender: "性别",
  educationLevel: "教育程度",
  jobLevel: "职位层级",
  jobPosition: "职位名称",
  department: "部门",
  company: "公司",
  address: "地址",
  enterRegister: "立即注册",
  management: "管理层",
  manager: "经理",
  supervisor: "主管",
  officer: "职员/员工",
  worker: "普工/操作员",
  doctorate: "博士",
  masterDegree: "硕士",
  bachelorDegree: "学士",
  highVocational: "高级职业证书",
  technicalVocational: "技术职业证书",
  vocational: "职业证书",
  highSchool: "高中",
  secondarySchool: "初中",
  primarySchool: "小学",
  lowerPrimary: "小学以下",
  male: "男",
  female: "女",
  other: "其他",
  profile: "个人资料",
  id: "ID",
  nameSurname: "姓名",
  sendRefCodeOtp: "参考码",
  requestOtpAgain: "重新获取验证码",
  edit: "编辑",
  add: "添加",
  addressSendReward: "收货地址",
  addressDetail: "详细地址",
  selectDefautAddress: "设为默认地址",
  addressEdit: "编辑地址",
  addressAdd: "新增地址",
  defaultValue: "默认值",
  hello: "您好 {name}",
  coinTotal: "总积分",
  homePage: "首页",
  activityPage: "活动",
  redemptPage: "兑换奖品",
  invitePage: "邀请好友",
  connectPlatformPage: "连接平台",
  connectPlatformPageHint: "连接电商平台以获取特权",
  birthDayPage: "生日礼品",
  addressPage: "收货地址",
  favoritePage: "我的收藏",
  cancelShipment: "取消发货",
  couponPage: "我的优惠券",
  myLuckyDrawPage: "我的抽奖",
  myMemberPage: "我的会员",
  registerMemberPage: "注册会员",
  statusDeliveryPage: "查看物流状态",
  transferPage: "积分转让",
  logout: "退出登录",
  textCategory: "分类",
  categoryAll: "全部",
  categoryRecommend: "推荐",
  categoryFood: "美食",
  categoryElectrical: "电子产品",
  categoryAppliance: "家用电器",
  categoryOther: "其他",
  totalValue: "剩余数量",
  detail: "详情",
  seeMoreDetail: "查看详情",
  youWant: "您确定要 ",
  delete: "删除",
  favoriteText: "在您的收藏中",
  waitingLoad: "请稍候",
  expireTime: "已过期",
  coin: "积分",
  surveyRegister: "注册表单",
  later: "稍后再说",
  redeem: "兑换",
  redeemPoint: "所用积分",
  confirmRedeem: "您确定要兑换吗？",
  confirmAdd: "您是否要添加",
  inYourFav: "到收藏夹",
  confirmDelete: "您确定要删除吗",
  fromYourFav: "从收藏夹中",
  balance: "余额",
  inviteFrindDetail: "只需邀请好友加入应用。当您的好友注册成功后，",
  received: "已领取",
  inviteFriend: "邀请好友",
  inviteFriendPhoneText: "输入您要邀请的手机号码",
  inviteFriendLineText: "通过 LINE 邀请好友",
  fillPhone: "输入好友手机号",
  historyRedeem: "兑换记录",
  historyCode: "券码记录",
  resendCode: "重新发送验证码",
  coinAll: "综合",
  coinReceived: "获得积分",
  coinUsed: "使用积分",
  activityAll: "所有活动",
  expireDate: "有效期至",
  note: "备注",
  enterNote: "输入备注...",
  checkIn: "签到",
  activityExpireDate: "活动截止日期",
  collectCoin: "赚取积分",
  valueItem: "数量",
  missionReward: "奖励",
  activityJoin: "参加活动",
  activityQr: "扫描二维码",
  activitySurvey: "参与调查",
  activityUpload: "上传活动成果",
  activityScanQr: "扫码",
  scanCode: "扫描代码",
  sendSurvey: "发送调查",
  uploadFile: "上传文件",
  sizeFile: "文件大小不得超过 10 MB",
  activityStatusJoin: "已参加的活动",
  activityStatusWait: "进行中的活动",
  activityStatusSuccess: "已完成的活动",
  activityStatusReject: "未通过的活动",
  activityStatusAll: "全部活动",
  registerToReceive: "注册领取",
  confirmUseCoupon: "确认使用优惠券",
  noteUseCoupon: "建议您在店内核销时再点击使用，以免权益失效。",
  noteAlertUseCoupon: "点击领取后，该代码将立即生效并视为已使用。",
  codeDiscount: "折扣码",
  errorQr: "二维码渲染失败",
  cancelRedemption: "您要取消交易吗？",
  cancelRedemptionNote: "如果取消交易，您将无法获得积分。",
  statusDelivery: "奖品派送状态",
  statusSendIn7Day: "7天内发货",
  shippingInProcess: "处理中",
  statusDeliverySuccess: "派送成功",
  statusDeliveryCancel: "取消派送",
  trackingNumber: "物流单号",
  receiveReward: "领取奖品",
  copyText: "已复制",
  confirmReceiveReward: "确认领取奖品",
  activitySuggest: "推荐活动",
  pageNotFound: "页面未找到",
  goBackPage: "返回上一页",
  goToLogin: "前往登录页面",
  changeLanguage: "语言",
  all: "全部",
  join: "参加",
  joined: "joined",
  success: "成功",
  failed: "失败",
  waiting: "等待中",
  pending: "待定",
  sent: "已发送",
  delivered: "已送达",
  textRequireOTPAgain: "重新获取验证码倒计时：",
  welcomeActivity: "欢迎参加活动",
  errQr: "二维码无效，请重试。",
  requireExam: "请完成问卷调查。",
  uploadSuccess: "结果已发送。",
  uploadWaiting: "审核将在 7 天内完成。",
  errDupActivity: "您已完成此任务，请选择其他活动。",
  errExpireActivity: "抱歉，该活动已过期。",
  errActivity: "抱歉，您不符合参加此活动的条件。",
  errFileUpload: "文件大小不能超过 10 MB。",
  errMyLuckyDrawNotEnough: "抱歉，您的抽奖次数不足。",
  expireDateUse: "过期日期",
  registerPage: "注册页面",
  shareActivity: "分享活动",
  goToMission: "前往活动",
  menuActivity: "活动",
  menuRedeem: "兑换",
  menuCoupon: "优惠券",
  privacyPolicy: "隐私政策",
  favoriteCategory: "收藏夹",
  deviceCategory: "电子设备",
  accessoryCategory: "电子配件",
  healthCategory: "健康美容",
  foodCategory: "食品饮料",
  babyCategory: "母婴玩具",
  petCategory: "宠物用品",
  homeCategory: "家居生活",
  menCategory: "男装时尚",
  womenCategory: "女装时尚",
  sportCategory: "运动户外",
  travelCategory: "旅行用品",
  reward: "奖励",
  missionComing: "即将开始的活动",
  startDate: "开始日期",
  endDate: "结束日期",
  home: "首页",
  activity: "活动",
  tracking: "物流追踪",
  account: "账户",
  historyCoupon: "优惠券记录",
  rewardSoHot: "热门奖品",
  hotMission: "热门活动",
  recommendMission: "推荐活动",
  doneDetailMission: "参与详情",
  detailMission: "活动详情",
  newActivityUpload: "重新提交",
  errNotTimeForActivity: "活动尚未开始。",
  news: "新闻资讯",
  birthDayGift: "生日礼品",
  friendRecommend: "推荐好友",
  friendRequest: "好友申请",
  friendList: "好友列表",
  rewardLimitReached: "奖品已领完",
  limitReached: "已达上限",
  limitReachedPerDay: "已达每日上限",
  textComingSoon: "敬请期待",
  textTimeCannotJoin: "不在活动期间内",
  couponExpired: "优惠券已过期",
  myLuckyDrawExpire: "已过期",
  conditionCoin: "适用条款",
  rewardPrize: "奖品",
  agree: "同意",
  disagree: "不同意",
  activityHeartToHeart: "发送消息",
  rewardComingSoon: "即将推出",
  addMember: "添加成员",
  conditionEntryPass: "准入条件",
  letsJoin: "立即加入",
  isUsed: "已使用",
  editProfile: "编辑资料",
  textProfile: "个人主页",
  searchMissionOrReward: "搜索活动或奖品",
  searchHistory: "搜索历史",
  removeSearchHistory: "清空搜索历史",
  messageActivityUpcoming: "敬请期待！新活动即将上线 🎉",
  messageActivityErrorReJoin: "操作失败。\n请直接从活动页面加入。",
  errActivityAlreadyJoined: "抱歉，您已参加过此活动。",
  errActivityDataNotFound: "抱歉，找不到活动信息。",
  redeemSuccessWithClaimInstruction: "兑换成功！请在“我的奖品”中领取。",
  redeemSuccess: "兑换成功",
  errRewardOutOfStock: "抱歉，该奖品已售罄。",
  errRedeemFail: "抱歉，兑换失败。请重试。",
  textSorry: "抱歉，",
  errDataNotFound: "抱歉，找不到相关数据。",
  errSubmissionFailed: "抱歉，提交失败。请重试。",
  errRegistrationFailedContactAdmin: "注册失败。请联系管理员。",
  btnRedirectMyCoupon: "前往我的优惠券",
  infoCouponReadyMyCoupons: "您可以在“我的优惠券”中使用您的优惠券。",
  coinCost: "所需积分",
  next: "下一步",
  skip: "跳过",
  otpVerified: "验证码已验证",
  successOTPVerified: "验证码验证成功",
  dataNotFound: "暂无数据",
  version: "版本",
  viewAll: "查看全部",
  availableStock: "剩余库存",
  expiredAt: "有效期至",
  expiredAt2: "到期时间",
  rewardToReceive: "待领取奖品",
  chooseRewardToReceive: "选择您的奖品",
  viewResultActivity: "查看活动结果",
  titleInvite: "{name} 邀请您加入我们的忠诚度计划并赚取专属奖励。",
  thankYouForParticipatingActivity: "感谢您的参与！",
  doActivityBy: "操作人：",
  textNotSpecified: "未指定",
  textIncognito: "匿名模式",
  viewHistory: "查看记录",
  history: "历史记录",
  locationName: "地点名称",
  location: "位置",
  selectRedeemRewardLocation: "选择领取点",
  selectAddressSendReward: "选择收货地址",
  instructionAddAddressSendReward: "请添加收货地址。",
  textSelect: "选择",
  instructionEnterRegisteredPhone: "如果您已有账户，请输入您的注册手机号。",
  instructionEnterRegisteredEmail: "如已注册，请输入已注册的邮箱。",
  textFirstRegistration: "首次注册",
  textClickHere: "点击这里",
  statusRegistrationSuccess: "注册成功",
  statusRegistrationFailed: "注册失败",
  instructionUploadIDPassport: "请上传您的身份证或护照。",
  textUploadIDPassport: "上传身份证 / 护照",
  rewardStartDate: "兑换开始日期",
  rewardExpiredDate: "奖品有效期",
  detailMyLuckyDraw: "参与详情",
  date: "日期",
  errUserNotFound: "抱歉，找不到该用户。",
  textSelectUser: "选择用户",
  textSelectFile: "选择文件",
  textImageType: "图片",
  textVideoType: "视频",
  instructionSelectOrAddAddress: "请选择或添加收货地址。",
  instructionSelectRewardMission: "请选择 {amount} 件奖品。",
  textTopRanking: "排行榜",
  textRank: "排名",
  textTotalAmount: "总计",
  viewProfile: "查看资料",
  addFriend: "添加好友",
  cancelFriend: "删除好友",
  removeFriendSuccess: "已成功从好友列表中删除",
  instructionUploadImageVideo: "上传图片/视频 (最大 {size}MB)",
  textUnsupportedFileType: "不支持的文件类型。",
  textAdditionalDescription: "补充说明",
  textDescription: "描述",
  textLocationOrBranchName: "地点 / 分店名称",
  textCheckInTime: "签到时间",
  textCheckOutTime: "签退时间",
  textLastUpdate: "最后更新",
  instructionLineReopenExternalBrowser: "请在外部浏览器中重新打开以进行登录。",
  errPhoneIsUsed: "抱歉，此手机号码已被使用。",
  textConditionEntryPassGamification: "参与条件",
  textFree: "免费",
  textCongratsReceived: "恭喜！🎉 您获得了",
  happyBirthMonth: "生日月快乐！",
  happyBirthMonthWish:
    "祝您在这个特殊的日子里充满欢乐、笑容和您应得的礼物！🎁 愿这一年为您带来所有美好的事物！",
  confirmDeleteMember: "您确定要删除成员 {name} 吗？",
  removeMemberSuccess: "成员已成功删除",
  removeMemberFail: "删除成员失败",
  confirmEditProfile: "您要保存对个人资料的更改吗？",
  bonusCoin: "奖励积分",
  receiveCoin: "您已获得积分",
  status: "状态",
  checkSendCodeHistory: "您可以在“我的优惠券”中查看您的代码。",
  errTimeOut: "抱歉，操作超时。",
  inviteHeadline: "好友越多，乐趣越多！",
  inviteFriendNow: "立即邀请您的好友加入应用！",
  copyInviteLink: "复制邀请链接",
  copyInviteLinkSuccess: "邀请链接已复制到剪贴板",
  detailScanQrCode: "请将二维码对准中心。",
  pleaseFill: "请填写",
  comment: "评论",
  claimSpecialGift: "领取特别礼物",
  claimGift: "领取礼品",
  claimGiftSuccess: "礼品领取成功",
  list: "列表",
  summary: "汇总",
  collected: "已收集",
  collectedItemCount: "已收集 {count} 件",
  invalidPhoneNumber: "请输入有效的手机号码",
  duplicateData: "重复数据",
  saveSuccess: "保存しました",
  uploadSuccessful: "上传成功",
  memberLevel: "当前等级",
  maxLevelReached: "恭喜！您已达到最高等级。🎉",
  // earnMoreForNextLevel: "再赚取 {nextLevelEarn} 积分即可达到 {nextLevelName}",
  earnMoreForNextLevel: "再赚取 {nextLevelEarn} 即可达到 {nextLevelName}",
  code: "代码",
  codeNo: "代码编号 {no}",
  qrCode: "二维码",
  barCode: "条形码",
  removeCache: "清除缓存",
  connect: "连接",
  luckyDrawCount: "机会次数",
  locationAccessDenied: "无法获取您的位置，请开启定位权限。",
  viewing: "正在查看",
  cameraError: {
    notAllowed: "请授予访问摄像头的权限",
    notFound: "错误：此设备上未找到摄像头",
    notSupported: "错误：需要安全上下文（HTTPS 或 localhost）",
    notReadable: "错误：摄像头是否已被占用？",
    overconstrained: "错误：安装的摄像头不适用",
    streamApiNotSupported: "错误：此浏览器不支持 Stream API",
    insecureContext:
      "错误：仅允许在安全上下文中访问摄像头。请使用 HTTPS 或 localhost。",
    unknown: "错误：摄像头错误 ({error_name})",
  },
  error: {
    title: "哎呀！出错啦",
    general: "出错了，请稍后再试。",
    unknown: "发生了未知错误",
    network: "网络错误，请检查您的网络连接。",
    timeout: "请求超时。",
    notFound: "抱歉，找不到所请求的信息。",
    unauthorized: "您没有访问此内容的权限。",
    sessionTimeout: "您的会话已过期，请重新登录。",
    heicNotSupported: "不支持 HEIC/HEIF 文件。请使用 JPG 或 PNG。",
    imageSupported: "仅支持 JPG、JPEG 和 PNG 文件。",
    ocrProductNotFound: "系统未找到与该标签匹配的的商品。",
  },
  yourCodeIs: "您的代码是",
  validation: {
    required: "必填项。",
    phoneInvalid: "手机号码无效",
    emailInvalid: "邮箱格式不正确",
    enterOTP: "请输入验证码",
    otpInvalid: "验证码必须为 6 位数字",
    uploadLimit: "最多允许上传 {number} 项",
    numberInvalid: "必须是数字",
    minCode: "请至少输入一个代码",
    maxFilesAllowed: "您最多可以上传 {count} 个文件",
    invalidFileFormat: "文件格式无效，请上传其他文件。",
  },
  redeemAmount: "兑换数量: {quantity}",
  duration: "时长",
  webAccessDenied: "拒绝访问：您没有权限访问此网站",
  webRedirecting: "正在重定向到正确的网站...",
  or: "或",
  notEnough: "余额不足",
  notAvailable: "不可用。",
  amount: "金额",
  message: "消息",
  loginLineLoading: "正在加载 LINE 登录...",
  signinWithLine: "使用 LINE 登录",
  signinWithGoogle: "使用 Google 登录",
  sampleImage: "示例图片",
  submitResult: "提交结果",
  submit: "提交",
  unit: {
    km: "公里",
    cc: "CC",
    unit: "个",
  },
  menuMain: "主菜单",
  menuMore: "更多",
  menuChatRoom: "Inbox",
  menuInformationCenter: "Info Center",
  menuInformationCenterFull: "Information Center",
  menuCampaign: "Campaign",
  menuRequest: "Request",
  menuWarranty: "Warranty",
  joinedCampaigns: "Joined Campaigns",
  campaignTotalPoint: "Total Point",
  campaignTotalAmount: "Total Amount",
  allRequest: "All Requests",
  newRequest: "New Request",
  textFilter: "Filter",
  textSortBy: "Sort by",
  textUpdated: "updated",
  textAttachmentCount: "{count} Attachments",
  textAttachmentFile: "Attachment Files",
  textFilePreview: "File Preview",
  textReply: "Reply",
  textReplyForm: "Reply Form",
  textForm: "Form",
  textFillInForm: "Fill in form",
  textPost: "Post",
  textInputComment: "Comment",
  textViewMoreComment: "View more comments",
  textViewMoreReply: "View more replies",
  textRewardCount: "× {count} item(s)",
  filterAll: "All",
  filterFavorite: "Favorited",
  filterUnread: "Unread",
  filterNoType: "No Type",
  filterReportStatus: "Status : {report_status_name}",
  sortDate: "Sort by Date",
  sortTitle: "Sort by Title",
  sortExpiredDate: "Sort by Expired Date",
  sortProduct: "Sort by Product",
  sortRegisterDate: "Sort by Register Date",
  clear: "Clear",
  addFavorite: "Add to Favorites",
  removeFavorite: "Remove from Favorites",
  extraBonus: "Extra Bonus",
  deliveryPickup: "Pickup",
  deliveryThailandPost: "Thailand Post",
  pleaseFillDetail: "please input detail here ...",
  textTitle: "Title",
  textSubtitle: "Subtitle",
  textType: "Type",
  textProduct: "Product",
  hintUploadMultiFile:
    "Max {fileLimit} files, maximum total file size is {fileLimitMB} MB",
  errorUploadLimitFileSize:
    "Total file size exceeds the {fileLimitMB} MB limit.",
  totalSummaryPoint: "Total Points",
  transferPoint: "Transfer Points",
  confirmTransferPoint:
    "Are you sure you want to transfer {point} points to {name}?",
  transferSuccess: "Points transferred successfully",
  transferDescription: "Transfer points to another member",
  selectRecipient: "Select recipient",
  selectMember: "Select member",
  enterTransferPoints: "Enter the number of points to transfer",
  transferPointAmount: "Points to transfer",
  transferPointType: "Type of Points to Transfer",
  transferPoints: "Transfer points",
  totalPoint: "Total point",
  myPointAll: "All",
  myPointExpire: "Expiring Soon",
  myPointExchange: "Redeem",
  total: "Total",
  toMember: "To",
  remaining: "Remaining",
  max: "Max",
  allWarranty: "All Warranties",
  warranty: "Warranty",
  warrantyRegistration: "Warranty Registration",
  newProductWarranty: "New Product",
  registerWarrantyDescription: "Register your purchase to activate your warranty.",
  registerNow: "Register Now",
  serviceRequest: "Service Request",
  warrantyStatus: {
    active: "ACTIVE",
    pending: "PENDING",
    rejected: "REJECTED",
    expired: "EXPIRED",
  },
  textUploadProductLabel: "Upload Product Label",
  textAutoFillByAI: "Auto-fill details with AI ✨",
  textBtnSelectPhoto: "Select Photo",
  textViewSamplePhoto: "View sample photo",
  textNumberMore: "+{number} more",
  textHide: "hide",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
